import { isMobile } from 'react-device-detect'
import DesktopCarousel from '../desktop'
import MobileCarousel from '../mobile'

export default isMobile ? MobileCarousel : DesktopCarousel